const state = {
  nextId: 1
}

export const getUniqueElementId = () => `app-id-${state.nextId++}`
